import { FC } from "react";

import { CreateGuestlistBlockForm } from "Bands/containers";

export const CreateGuestlistBlockPage: FC = () => {
  return <CreateGuestlistBlockForm />;
};
